import React from 'react'
import type { Translation } from '../../i18n'
import { serif, warm900, warm700, warm500, warm300, cream, stone, textMuted } from './tokens'

type Props = { l: Translation['landing']['processo'] }

export const ProcessoSection: React.FC<Props> = ({ l }) => (
  <section id="processo" className="grid md:grid-cols-2 gap-16 items-start px-10 md:px-20 py-24" style={{ background: cream }}>
    <div>
      <p className="flex items-center gap-3 text-[0.75rem] font-medium tracking-[0.18em] uppercase mb-4" style={{ color: warm500 }}>
        <span className="w-6 h-px inline-block" style={{ background: warm500 }} />
        {l.sectionLabel}
      </p>
      <h2
        className="text-[clamp(2rem,3.5vw,3rem)] font-light leading-[1.15] mb-6"
        style={{ fontFamily: serif, color: warm900 }}
      >
        {l.title}
      </h2>
      <div className="px-6 py-5 rounded-[0_2px_2px_0]" style={{ borderLeft: `3px solid ${warm300}`, background: '#fdf8f2' }}>
        <p className="text-[0.85rem] leading-[1.7] italic" style={{ color: textMuted }}>
          <strong className="not-italic" style={{ color: warm700 }}>{l.transparencia.label}. </strong>
          {l.transparencia.body}
        </p>
      </div>
    </div>
    <div>
      {l.steps.map((step, i) => (
        <div
          key={i}
          className={`grid gap-5 py-6 ${i < l.steps.length - 1 ? 'border-b' : ''}`}
          style={{ gridTemplateColumns: '48px 1fr', borderColor: stone }}
        >
          <span className="font-light leading-none pt-1 text-[1.8rem]" style={{ fontFamily: serif, color: warm300 }}>
            {String(i + 1).padStart(2, '0')}
          </span>
          <div>
            <h4 className="font-semibold mb-1 text-[1.1rem]" style={{ fontFamily: serif, color: warm900 }}>{step.title}</h4>
            <p className="text-[0.85rem] leading-[1.7]" style={{ color: textMuted }}>{step.body}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
)
